export const CATEGORY_SET = 'CATEGORY_SET';
export const CATEGORY_CLEAR = 'CATEGORY_CLEAR';
